/*-----------------------------------------------------------------
- Page mixin
-----------------------------------------------------------------*/
import Page from '@/mixins/Page';

export default {
    
    mixins: [Page],
    
    /**
     * Start `loading-page` before create
     */
    beforeCreate() {
        this.$wait.start('loading-page');
    },
    
    /**
     * Start `loading-page` before leaving current route
     *
     * @param {object} to
     * @param {object} from
     * @param {Function} next
     */
    beforeRouteLeave(to, from, next) {
        this.$wait.start('loading-page');
        
        setTimeout(() => next(), 400);
    },
    
    /**
     * Start `loading-page` before updating route
     *
     * @param {object} to
     * @param {object} from
     * @param {Function} next
     */
    beforeRouteUpdate(to, from, next) {
        this.$wait.start('loading-page');
        
        setTimeout(() => next(), 400);
    },
    
    /**
     * @inheritDoc
     */
    breadcrumbs() {
        return null;
    },
    
    /**
     * @inheritDoc
     */
    data() {
        return {
            pageTitle : null,
            watchQuery: false,
        };
    },
    
    /**
     * @inheritDoc
     */
    metaInfo() {
        return {
            title: this.pageTitle,
        };
    },
    
    /**
     * @inheritDoc
     */
    created() {
        this.watchQuery = true;
        this.fetchWrapper();
    },
    
    watch: {
        '$route': function () { // eslint-disable-line
            if (this.watchQuery) {
                this.fetchWrapper();
            }
        },
    },
    
    methods: {
        /**
         * Fetching data wrapper
         */
        async fetchWrapper() {
            await this.fetch().then(() => this.$wait.end('loading-page'));
        },
        
        /**
         * Fetching data
         */
        fetch() {
            return new Promise((resolve) => resolve());
        },
        
        /**
         * Fetching data
         */
        reFetch() {
            this.$wait.start('loading-page');
            this.fetchWrapper();
        },
        
        /**
         * Set rogue props data
         *
         * @param {string} name - rogue name
         * @param {*} data -prop data
         */
        setProp(name, data) {
            const find = this.rogues.find((item) => item.name === name);
            const index = this.rogues.findIndex((item) => item.name === name);

            this.rogues[index] = { ...find, props: { ...find.props, ...data } };
        },

        /**
         * Set rogue showing status
         *
         * @param {string} name - rogue name
         * @param {*} status - status
         */
        setShow(name, status) {
            const find = this.rogues.find((item) => item.name === name);
            const index = this.rogues.findIndex((item) => item.name === name);

            this.rogues[index] = { ...find, show: status };
        },

        /**
         * Check the Promise.all Request Error
         * 
         * @param {Array} req - Responses array
         * @param {index} index - number of response
         * @returns {boolean}
         */
        handleReq(req, index) {
            return req && req[index] && !req[index].isAxiosError;
        },
    },
    
};
